import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/author.png'
import _imports_1 from '../../assets/images/icon-right-red.png'
import _imports_2 from '../../assets/images/blog-4.jpg'
import _imports_3 from '../../assets/images/icon-left-red.png'


const _withScopeId = n => (_pushScopeId("data-v-21865dab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "blog-single-item top-single-blog bg-white" }
const _hoisted_3 = { class: "d-lg-flex align-items-center" }
const _hoisted_4 = { class: "flex-grow-1 me-lg-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rounded-circle",
    alt: "author"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Posted by"),
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, "Adli")
], -1))
const _hoisted_7 = { class: "ps-0 mb-0 list-unstyled tags" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "icon-right-red"
}, null, -1))
const _hoisted_9 = { class: "flex-shrink-0 mt-4 mt-lg-0 text-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "blog"
}, null, -1))
const _hoisted_11 = { class: "row justify-content-center" }
const _hoisted_12 = ["data-aos-delay"]
const _hoisted_13 = { class: "blog-single-item transition-y bg-white" }
const _hoisted_14 = { class: "flex-shrink-0" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "flex-grow-1 ms-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Posted by", -1))
const _hoisted_18 = { class: "mb-0" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "ps-0 mb-0 list-unstyled tags" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-12\" data-v-21865dab><div class=\"pagination-area text-center\" data-v-21865dab><a href=\"#\" class=\"next page-numbers\" data-v-21865dab><img src=\"" + _imports_3 + "\" alt=\"arrow-right-2\" data-v-21865dab></a><span class=\"page-numbers current\" aria-current=\"page\" data-v-21865dab>1</span><a href=\"#\" class=\"page-numbers\" data-v-21865dab>2</a><a href=\"#\" class=\"page-numbers\" data-v-21865dab>3</a><a href=\"#\" class=\"next page-numbers\" data-v-21865dab><img src=\"" + _imports_1 + "\" alt=\"arrow-right\" data-v-21865dab></a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/blog-details",
            class: "d-flex align-items-center text-decoration-none author"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/blog-details" }, {
                default: _withCtx(() => [
                  _createTextVNode("Paid Advert")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/blog-details" }, {
                default: _withCtx(() => [
                  _createTextVNode("Google Search")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("h3", null, [
            _createVNode(_component_router_link, { to: "/blog-details" }, {
              default: _withCtx(() => [
                _createTextVNode(" Demystifying Paid Search Ads: A Beginner's Guide ")
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_router_link, {
            to: "/blog-details",
            class: "read-more"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" READ MORE "),
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: "/blog-details",
            class: "d-block blog-img mb-0"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogs, (blog) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-xl-4 col-md-6",
          key: blog.id,
          "data-aos": "fade-up",
          "data-aos-duration": "1200",
          "data-aos-delay": blog.dataDelay
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_router_link, {
              to: "/blog-details",
              class: "d-flex align-items-center text-decoration-none author"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("img", {
                    src: blog.authorImage,
                    class: "rounded-circle",
                    alt: "author"
                  }, null, 8, _hoisted_15)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("h6", _hoisted_18, _toDisplayString(blog.authorName), 1)
                ])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_router_link, {
              to: "/blog-details",
              class: "d-block blog-img"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: blog.image,
                  alt: "blog"
                }, null, 8, _hoisted_19)
              ]),
              _: 2
            }, 1024),
            _createElementVNode("h3", null, [
              _createVNode(_component_router_link, { to: "/blog-details" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(blog.title), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("ul", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blog.tags, (tag) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: tag.id
                }, [
                  _createVNode(_component_router_link, { to: "/blog-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tag.tag), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128))
            ])
          ])
        ], 8, _hoisted_12))
      }), 128)),
      _hoisted_21
    ])
  ]))
}